import {
  NO_KEYBOARD_LAYOUT,
  type ReplacementDraft,
  type ValidatedAddress,
} from "@/pages/Replacement/replacement.types";
import type {
  ReplacementOrderAddress,
  ReplacementOrderDelivery,
  ReplacementOrderRequest,
} from "./replacement-order.types";

const toOrderAddress = (saved: ValidatedAddress): ReplacementOrderAddress => ({
  address: saved.address,
  ...(saved.deliveryInstructions ? { deliveryInstructions: saved.deliveryInstructions } : {}),
});

const toDelivery = (draft: ReplacementDraft): ReplacementOrderDelivery => {
  if (draft.deliveryMethod === "ship") {
    if (!draft.shippingAddress) {
      throw new Error("Cannot place a ship replacement order without a saved shipping address");
    }
    return { method: "ship", shippingAddress: toOrderAddress(draft.shippingAddress) };
  }
  if (draft.deliveryMethod === "pickup") {
    if (!draft.pickup) {
      throw new Error("Cannot place a pickup replacement order without a chosen building");
    }
    return {
      method: "pickup",
      pickup: draft.pickup,
      ...(draft.homeAddress ? { homeAddress: toOrderAddress(draft.homeAddress) } : {}),
    };
  }
  throw new Error("Cannot place a replacement order without a delivery method");
};

export const toReplacementOrderRequest = (draft: ReplacementDraft): ReplacementOrderRequest => {
  if (!draft.deviceId) {
    throw new Error("Cannot place a replacement order without a chosen device");
  }
  const keyboardLayout =
    draft.keyboardLayout && draft.keyboardLayout !== NO_KEYBOARD_LAYOUT
      ? draft.keyboardLayout
      : undefined;
  return {
    deviceId: draft.deviceId,
    ...(keyboardLayout ? { keyboardLayout } : {}),
    delivery: toDelivery(draft),
  };
};
